const menuInit = () => {
    const dropdowns = document.querySelectorAll('.menu-item-has-children');
    const active = 'menu__item--active';
    const hide = 'hide';
    const show = 'show';
    const showFlex = 'show-flex';
    const width = screen.width;

    const mobileMain = document.querySelector('.navModal__main');
    const mobileItemsTop = document.querySelector('.navModal__navMain');
    const mobileItemsBottom = document.querySelector('.navModal__navTop');
    const backBtn = document.querySelector('.navModal__back');
    const allSubMenus = document.querySelectorAll('.sub-menu');

    if (width > 831) {
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('mouseover', (e) => {
                dropdown.classList.add(active);
    
                let currentDropdown = dropdown.querySelector('.sub-menu');
    
                document.addEventListener('mouseover', (e) => {
                    if(!dropdown.contains(e.target) && !currentDropdown.contains(e.target)) {
                        dropdown.classList.remove(active);
                    }
                });
            });
        });
    } else {
        dropdowns.forEach((dropdown, index) => {

            let currentDropdown = dropdown.querySelector('.sub-menu');
            currentDropdown.classList.add(`submenu-${index}`);

            mobileMain.appendChild(currentDropdown);

            dropdown.addEventListener('click', (e) => {

                mobileItemsTop.classList.toggle(hide);
                mobileItemsBottom.classList.toggle(hide);

                backBtn.classList.add(showFlex);

                mobileMain.querySelector(`.submenu-${index}`).classList.add(show);
            });
        });

        backBtn.addEventListener('click', () => {
            backBtn.classList.toggle(showFlex);

            allSubMenus.forEach(submenu => {
                if (submenu.classList.contains(show)) {
                    submenu.classList.remove(show);
                }
            });
            mobileItemsTop.classList.toggle(hide);
            mobileItemsBottom.classList.toggle(hide);
        });

    }
}

menuInit();

